<template>
  <div class="robot-list-panel">
    <!-- 科技感装饰元素 -->
    <div class="tech-corner top-left"></div>
    <div class="tech-corner top-right"></div>
    <div class="tech-corner bottom-left"></div>
    <div class="tech-corner bottom-right"></div>

    <div class="panel-header">
      <div class="title">
        <svg-icon name="robot" class="title-icon"></svg-icon>
        {{ langMap.robotList[lang] }}
      </div>
      <div class="header-decoration"></div>
    </div>

    <div class="robot-list">
      <div
        class="robot-item"
        v-for="robot in robotList"
        :key="robot.id"
        :class="{ 'active': selectedRobotId === robot.id, 'offline': !robot.online }"
        @click="selectRobot(robot)"
      >
        <div class="robot-info">
          <div class="robot-icon">
            <img src="@/assets/images/voice/Robot-icon.png" alt="robot" class="robot-img" :class="{'floating': robot.online}">
          </div>
          <div class="robot-details">
            <div class="robot-name">{{ robot.name }}</div>
            <div class="robot-serial">{{ robot.code }}</div>
            <div class="robot-status">
              <div class="status-indicator" :class="{ 'online': robot.online, 'offline': !robot.online }"></div>
              {{ robot.online ? langMap.online[lang] : langMap.offline[lang] }}
            </div>
          </div>
        </div>
        <div class="select-indicator">
          <div class="check-circle" v-if="selectedRobotId === robot.id">
            <svg-icon name="check" class="check-icon"></svg-icon>
          </div>
        </div>
      </div>
    </div>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <div class="pagination">
        <div class="page-btn prev"
             @click="prevPage"
             :class="{ disabled: currentPage <= 1 }">
          <svg-icon name="arrow" class="page-icon arrow-left" />
        </div>

        <div class="page-info">
          <div class="current-page">{{ currentPage }}</div>
          <div class="page-divider"></div>
          <div class="total-page">{{ totalPages }}</div>
        </div>

        <div class="page-btn next"
             @click="nextPage"
             :class="{ disabled: currentPage >= totalPages }">
          <svg-icon name="arrow" class="page-icon arrow-right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { getTenantId } from "@/libs/util";
import langMap from '@/utils/language';
import { mapState } from 'vuex';

export default {
  name: 'RobotListPanel',
  props: {
    selectedRobotId: {
      type: [String, Number],
      default: null
    },
    isClick:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      langMap: langMap,
      robotList: [],
      currentPage: 1,
      pageSize: 15,
      total: 0,
      tenantId: getTenantId()
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language
    }),
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    }
  },
  mounted() {
    this.getRobotList();
  },
  methods: {
    // 获取机器人列表
    async getRobotList() {
      try {
        const response = await api.getData(`robot-server/robot/list?index=${this.currentPage}`);
        if (response.state === 1) {
          this.robotList = response.data.rows.map(robot => ({
            id: robot.id,
            name: robot.name,
            code: robot.code,
            online: robot.onlineStatus,
            avatar: require('@/assets/images/voice/Robot-icon.png'),
            pursuitFuncEnable:robot.pursuitFuncEnable,
            lowBattery:robot.lowBattery || 20
          }));
          this.total = response.data.total;
        } else {
          this.$Notice.error({
            title: langMap.error[this.lang],
            desc: response.msg || langMap.getRobotListFailed[this.lang]
          });
        }
      } catch (error) {
        console.error('获取机器人列表失败:', error);
        this.$Notice.error({
          title: langMap.error[this.lang],
          desc: langMap.getRobotListFailed[this.lang]
        });
      }
    },

    // 选择机器人
    selectRobot(robot) {
      if (!robot.online && !this.isClick) {
        this.$Notice.warning({
          title: langMap.tip[this.lang],
          desc: langMap.robotOfflineCannotSelect[this.lang]
        });
        return;
      }

      this.$emit('select-robot', robot , !robot.online && this.isClick);
    },

    // 上一页
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getRobotList();
      }
    },

    // 下一页
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getRobotList();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.robot-list-panel {
  position: relative;
  width: 100%;
  height: 100%;
  background: rgba(10, 25, 50, 0.8);
  border-radius: 15px;
  border: 1px solid rgba(0, 191, 255, 0.3);
  backdrop-filter: blur(10px);
  box-shadow:
    0 0 20px rgba(0, 191, 255, 0.1),
    inset 0 0 10px rgba(0, 191, 255, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 科技感边角 */
.tech-corner {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid rgba(0, 191, 255, 0.6);
  z-index: 5;
}

.top-left {
  top: 0;
  left: 0;
  border-right: none;
  border-bottom: none;
  border-top-left-radius: 5px;
}

.top-right {
  top: 0;
  right: 0;
  border-left: none;
  border-bottom: none;
  border-top-right-radius: 5px;
}

.bottom-left {
  bottom: 0;
  left: 0;
  border-right: none;
  border-top: none;
  border-bottom-left-radius: 5px;
}

.bottom-right {
  bottom: 0;
  right: 0;
  border-left: none;
  border-top: none;
  border-bottom-right-radius: 5px;
}

.panel-header {
  padding: 20px;
  border-bottom: 1px solid rgba(0, 191, 255, 0.2);
  position: relative;
}

.title {
  font-size: 18px;
  font-weight: bold;
  color: #00bfff;
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 20px;
  color: #00bfff;
}

.header-decoration {
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00bfff, transparent);
  animation: glow-line 2s infinite alternate;
}

.robot-list {
  padding: 10px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 191, 255, 0.3) transparent;
  height: ~'calc(100% - 135px)';
}

.robot-list::-webkit-scrollbar {
  width: 6px;
}

.robot-list::-webkit-scrollbar-track {
  background: rgba(0, 191, 255, 0.1);
  border-radius: 3px;
}

.robot-list::-webkit-scrollbar-thumb {
  background: rgba(0, 191, 255, 0.3);
  border-radius: 3px;
}

.robot-list::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 191, 255, 0.5);
}

.robot-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  margin-bottom: 10px;
  background: rgba(15, 35, 70, 0.6);
  border: 1px solid rgba(0, 191, 255, 0.2);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.robot-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 191, 255, 0.1), transparent);
  transition: left 0.5s ease;
}

.robot-item:hover::before {
  left: 100%;
}

.robot-item:hover {
  border-color: rgba(0, 191, 255, 0.5);
  box-shadow: 0 0 15px rgba(0, 191, 255, 0.2);
  transform: translateY(-2px);
}

.robot-item.active {
  background: rgba(0, 191, 255, 0.1);
  border-color: #00bfff;
  box-shadow: 0 0 20px rgba(0, 191, 255, 0.3);
}

.robot-item.offline {
  opacity: 0.6;
}

.robot-item.offline:hover {
  transform: none;
  box-shadow: none;
}

.robot-info {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
}

.robot-icon {
  position: relative;
  width: 50px;
  height: 50px;
}

.robot-img {
  width: 100%;
  height: 100%;
}

.robot-img.floating {
  animation: floating 3s ease-in-out infinite;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  flex-shrink: 0;
}

.status-indicator.online {
  background: #00ff88;
  box-shadow: 0 0 8px rgba(0, 255, 136, 0.6);
  animation: pulse-green 2s infinite;
}

.status-indicator.offline {
  background: #ff4444;
}

.robot-details {
  flex: 1;
}

.robot-name {
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 4px;
}

.robot-serial {
  font-size: 14px;
  color: #ffca00;
  margin-bottom: 2px;
}

.robot-status {
  font-size: 11px;
  color: rgba(0, 191, 255, 0.8);
  display: flex;
  align-items: center;
}

.select-indicator {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.check-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #00bfff;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: check-appear 0.3s ease;
}

.check-icon {
  font-size: 14px;
  color: #ffffff;
}

.pagination-container {
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 10px;
  background: rgba(16, 32, 58, 0.7);
  border-radius: 16px;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 191, 255, 0.3);
}

.page-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 191, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.page-btn:hover:not(.disabled) {
  background: rgba(0, 191, 255, 0.5);
  transform: scale(1.1);
  box-shadow: 0 0 15px rgba(0, 191, 255, 0.5);
}

.page-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-icon {
  font-size: 16px;
  color: #fff;
}

.arrow-right {
  transform: rotate(180deg);
}

.page-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}

.current-page {
  min-width: 24px;
  text-align: center;
  animation: numberChange 0.3s ease;
  color: rgba(0, 191, 255, 0.9);
}

.page-divider {
  width: 15px;
  height: 2px;
  background: linear-gradient(90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.8) 50%,
    transparent 100%
  );
}

.total-page {
  min-width: 24px;
  text-align: center;
  opacity: 0.8;
}

/* 动画定义 */
@keyframes glow-line {
  0% {
    opacity: 0.5;
    box-shadow: 0 0 5px rgba(0, 191, 255, 0.3);
  }
  100% {
    opacity: 1;
    box-shadow: 0 0 15px rgba(0, 191, 255, 0.6);
  }
}

@keyframes pulse-green {
  0% {
    box-shadow: 0 0 8px rgba(0, 255, 136, 0.6);
  }
  50% {
    box-shadow: 0 0 15px rgba(0, 255, 136, 0.9);
  }
  100% {
    box-shadow: 0 0 8px rgba(0, 255, 136, 0.6);
  }
}

@keyframes check-appear {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes numberChange {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes floating {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-6px);
  }
}
</style>
